import { Pipe, PipeTransform } from '@angular/core';
import {
    ProcessHistoryState,
    ProcessHistoryStateTitleMap
} from '@app/views/admin/components/sync-history-timeline/models/process-history-state.model';

@Pipe({
    name: 'processHistoryStateTitle'
})
export class ProcessHistoryStateTitlePipe implements PipeTransform {

    transform(state: ProcessHistoryState): string {
        return ProcessHistoryStateTitleMap.has(state)
            ? ProcessHistoryStateTitleMap.get(state)
            : '';
    }

}
